<template>
  <div class="talkview compare-face-box">
    <ul class="compare-face-ul">
      <li>
        <p>监考流程图</p>
        <el-image
          class="img"
          fit="contain"
          :src="invigilationPicUrl"
          :preview-src-list="[invigilationPicUrl]"
        >
        </el-image>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "flow-chart",
  data() {
    return {
      invigilationPicUrl: "",
    };
  },
  async created() {
    this.getImgs();
    this.onWebConnect()
  },
  methods: {
    onWebConnect() {
      const _this = this;
      if (window.core) {
        const connectTalkWindowUpdated = function (isOpen) {
          _this.onHandleTalkWindowUpdated(isOpen)
        }
        // 订阅原生事件
        // 推巡检音频流成功
        window.core.talkWindowUpdated.connect(connectTalkWindowUpdated)
        this.$once("hook:beforeDestroy", () => {
          // 销毁页面后取消订阅，避免多次订阅
          window.core.talkWindowUpdated.disconnect(connectTalkWindowUpdated)
        });
      } else {
        setTimeout(() => {
          _this.onWebConnect()
        }, 1000)
      }
    },
    onHandleTalkWindowUpdated(isOpen) {
      if (isOpen) {
        this.getImgs()
      } else {
      }
    },
    async getImgs() {
      const { invigilationPicUrl } = this.$utils.$localStorage.get("flowChart")
      this.invigilationPicUrl = await this.$HTTP.ApiOss.signatureUrl(invigilationPicUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.talkview {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
  word-break: break-all;
  overflow: hidden;
  padding-top: 20px;
}
.compare-face-box h4,
.compare-face-box ul,
.compare-face-box li {
  padding: 0;
  margin: 0;
}
.compare-face-box h4 {
  text-align: center;
  margin-top: 20px;
  font-size: 20px;
}
.compare-face-box li {
  list-style: none;
}
.compare-face-ul {
  margin-top: 10px !important;
  display: flex;
  justify-content: space-between;
}
.compare-face-ul li {
  flex: 1;
  text-align: center;
}
.compare-face-ul p {
  margin: 10px 0;
  padding: 7px 0;
  background: #ebeef5;
  color: #606266;
  font-weight: bold;
}
.compare-face-ul img {
  display: block;
  // margin: 0 auto;
  // width: 95%;
  // height: auto;
  // object-fit: contain;
}
.img {
  margin: 0 auto;
  width: 95%;
  height: 500px;
}
</style>
